module.exports = __webpack_public_path__ + "img/Group9060.81ec0706.svg";